module.exports = __webpack_public_path__ + "static/img/图层 515.0796fd1a.png";